import diodes from './diodes';
import users from './users';
import events from './events';
import telemetry from './telemetry';


export default {
  events,
  telemetry,
  diodes,
  users
};
